<div class="home-page">
  <section id="home" class="home-hero" aria-label="Introduction">
    <div class="home-hero__container animate-fade-in-up">
      <nav aria-label="Metrics" class="home-hero__metrics">
        <ol>
          <li>12 Years</li>
          <li>/</li>
          <li>8 Countries</li>
          <li>/</li>
          <li>500+ AI Deployments</li>
          <li>/</li>
          <li class="home-hero__metrics-active">
            <span class="home-hero__metrics-ping-wrap" aria-hidden="true">
              <span class="home-hero__metrics-ping"></span>
              <span class="home-hero__metrics-dot"></span>
            </span>
            Cognitive Infrastructure
          </li>
        </ol>
      </nav>

      <div class="home-hero__title">
        Unlimited <span>Possibilities.</span><br />
        Future of Intelligence.
      </div>

      <p class="home-hero__copy">
        For over 12 years, Rêve has built the digital backbone of global enterprises. Today, we leverage that
        profound infrastructural expertise to securely orchestrate Large Language Models and deploy autonomous
        AI agents directly into your core business workflows.
      </p>

      <div class="home-hero__actions">
        <a class="btn btn--solid" routerLink="/services" (click)="scrollToTop()">View Capabilities</a>
        <button type="button" class="btn btn--outline" (click)="openCalendlyPopup()">
          Direct Inquiry
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M5 12h14M12 5l7 7-7 7"></path>
          </svg>
        </button>
      </div>
    </div>
  </section>

  <section class="alliances" aria-label="Strategic Alliances">
    <div class="alliances__container">
      <div class="alliances__head">
        <div class="alliances__head-left">
          <div class="eyebrow">Strategic Ecosystem</div>
          <h2 class="title">
            Engineered alongside the world's leading technology providers.
          </h2>
        </div>
        <div class="alliances__head-right">
          Partnering with top-tier cloud platforms and security vendors to guarantee enterprise-grade
          delivery.
        </div>
      </div>

      <div class="alliances__grid">
        <article class="partner-card">
          <div>
            <h3 class="partner-card__name">AWS</h3>
            <div class="partner-card__sub">Partner Network</div>
          </div>
          <div class="partner-card__list">
            <div><span></span><span>Advanced Consulting</span></div>
            <div><span></span><span>Analytics & ML</span></div>
          </div>
        </article>

        <article class="partner-card">
          <div>
            <h3 class="partner-card__name">Microsoft</h3>
            <div class="partner-card__sub">Azure Partner</div>
          </div>
          <div class="partner-card__list">
            <div><span></span><span>Gold Competency</span></div>
          </div>
        </article>

        <article class="partner-card">
          <div>
            <h3 class="partner-card__name">Google</h3>
            <div class="partner-card__sub">Cloud Platform</div>
          </div>
          <div class="partner-card__list">
            <div><span></span><span>Cloud Partner</span></div>
          </div>
        </article>

        <article class="partner-card">
          <div>
            <h3 class="partner-card__name">VMware</h3>
            <div class="partner-card__sub">Enterprise Partner</div>
          </div>
          <div class="partner-card__list">
            <div><span></span><span>Master Services</span></div>
          </div>
        </article>
      </div>

      <div class="alliances__ecosystem">
        <div class="alliances__ecosystem-title">Technology<br />Ecosystem</div>
        <div class="alliances__ecosystem-list">
          <span>Oracle Cloud</span>
          <span>Red Hat</span>
          <span>Palo Alto</span>
          <span>CrowdStrike</span>
          <span>Snyk</span>
          <span>Aryaka</span>
          <span>DevRev</span>
          <span>Freshworks</span>
          <span>Yotta</span>
        </div>
      </div>
    </div>
  </section>

  <section class="capabilities" aria-label="Core Capabilities">
    <div class="capabilities__container">
      <div class="capabilities__head">
        <div class="eyebrow">Core Capabilities</div>
        <h2 class="title">
          Intelligence applied for Business Innovation.
        </h2>
      </div>

      <div class="capabilities__content">
        <div class="capabilities__left">
          <div class="capabilities__label">01. The Approach</div>
          <div class="capabilities__items">
            <article>
              <h3 class="capabilities__item-title">Model-Agnostic Orchestration</h3>
              <div class="capabilities__item-copy">
                We design deeply tailored generative solutions that align strictly with your business
                objectives, entirely free from model lock-in. Our engineers ensure seamless transitions
                between OpenAI, Anthropic, Gemini, and open-source models based on specific task
                reasoning constraints.
              </div>
            </article>
            <article>
              <h3 class="capabilities__item-title">Agentic Execution</h3>
              <div class="capabilities__item-copy">
                We systematically eliminate manual IT toil via autonomous L0 agents. From automated
                backend provisioning to self-healing security remediations, we radically reduce
                operational drag by giving AI direct, secure execution capabilities over your APIs.
              </div>
            </article>
            <article>
              <h3 class="capabilities__item-title">Zero-Trust Data Sovereignty</h3>
              <div class="capabilities__item-copy">
                In the age of LLMs, perimeter defense is insufficient. We embed zero-trust security
                architectures into the fabric of your AI environment, utilizing strict RAG pipelines so
                your IP never leaks to public training sets.
              </div>
            </article>
            <article>
              <h3 class="capabilities__item-title">Cognitive Infrastructure</h3>
              <div class="capabilities__item-copy">
                The required 5% foundation. We engineer the high-availability data lakes and
                GPU-optimized hybrid cloud environments necessary to run and scale your proprietary
                intelligence without compute throttling.
              </div>
            </article>
          </div>
        </div>

        <div class="capabilities__right">
          <div class="capabilities__right-head">
            <span>02. Execution Vectors</span>
            <span>Key Services</span>
          </div>

          <div class="capabilities__preview-list">
            @for (service of servicesPreview; track service) {
            <a class="capabilities__preview-card" [routerLink]="['/services', service.id]"
              [attr.aria-label]="'View ' + service.name + ' service details'" (click)="scrollToTop()">
              <div class="capabilities__preview-title-row">
                <h3 class="capabilities__preview-title">{{ service.name }}</h3>
                <svg viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M5 12h14M12 5l7 7-7 7"></path>
                </svg>
              </div>
              <div class="capabilities__preview-copy">{{ service.desc }}</div>
            </a>
            }
          </div>

          <div class="capabilities__all-link">
            <a routerLink="/services" (click)="scrollToTop()">View all Architectural Capabilities</a>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="testimonials" aria-label="Customer Testimonials">
    <div class="testimonials__container">
      <div class="testimonials__head">
        <div class="eyebrow">Enterprise Validation</div>
        <h2 class="title">Proven impact across global enterprises.</h2>
      </div>

      <div class="testimonials__grid">
        <article class="testimonial-card">
          <span class="testimonial-card__quote">"</span>
          <div class="testimonial-card__copy">
            Rêve transformed our sprawling infrastructure. Their model-agnostic approach and rigorous AI
            governance cut our hybrid operational costs by 35%.
          </div>
          <div class="testimonial-card__author-row">
            <div class="testimonial-card__avatar">D</div>
            <div>
              <div class="testimonial-card__name">David Chen</div>
              <div class="testimonial-card__role">Chief Information Officer</div>
            </div>
          </div>
        </article>

        <article class="testimonial-card">
          <span class="testimonial-card__quote">"</span>
          <div class="testimonial-card__copy">
            The L0 autonomous agents completely re-engineered our support layer. We are seeing a 45%
            zero-touch resolution rate.
          </div>
          <div class="testimonial-card__author-row">
            <div class="testimonial-card__avatar">P</div>
            <div>
              <div class="testimonial-card__name">Priya Sharma</div>
              <div class="testimonial-card__role">VP of Global Operations</div>
            </div>
          </div>
        </article>

        <article class="testimonial-card">
          <span class="testimonial-card__quote">"</span>
          <div class="testimonial-card__copy">
            Migrating our monolithic systems to a vector database was daunting. Rêve executed a
            zero-downtime modernization while embedding zero-trust LLM security.
          </div>
          <div class="testimonial-card__author-row">
            <div class="testimonial-card__avatar">M</div>
            <div>
              <div class="testimonial-card__name">Marcus Vance</div>
              <div class="testimonial-card__role">Director of Cloud Architecture</div>
            </div>
          </div>
        </article>
      </div>
    </div>
  </section>

  <!-- <section id="contact" class="contact-section" aria-label="Contact Us">
  <div class="contact-section__container">
    <div class="contact-section__grid">
      <div>
        <div class="eyebrow">Connect</div>
        <div class="title">Discover the future of applied AI.</div>
        <div class="contact-section__copy">
          Connect with our delivery experts to audit your topology and map your enterprise integration
          roadmap.
        </div>
      </div>

      <div class="contact-card">
        <div class="contact-card__corner" aria-hidden="true"></div>
        <div class="contact-card__title">Direct Inquiry</div>

        <div *ngIf="submitted" role="alert" class="contact-card__success animate-fade-in-up">
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <polyline points="20 6 9 17 4 12"></polyline>
          </svg>
          <div>Request securely logged. Our architecture team will reach out within one business day.
          </div>
        </div>

        <form *ngIf="!submitted" [formGroup]="contactForm" (ngSubmit)="onSubmit()" class="contact-form">
          <div class="contact-form__field">
            <input type="text" formControlName="name" placeholder="Full Name" />
          </div>

          <div class="contact-form__row">
            <div class="contact-form__field">
              <input type="email" formControlName="email" placeholder="Corporate Email" />
            </div>
            <div class="contact-form__field">
              <input type="text" formControlName="company" placeholder="Organization" />
            </div>
          </div>

          <div class="contact-form__field">
            <textarea rows="3" formControlName="message"
            placeholder="Brief context of operational challenges..."></textarea>
          </div>

          <button type="submit" [disabled]="contactForm.invalid || isSubmitting"
            class="contact-form__submit">
            <span *ngIf="!isSubmitting">Transmit Request</span>
            <span *ngIf="isSubmitting" class="contact-form__submit-loading">
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <circle cx="12" cy="12" r="10"></circle>
                <path d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
              </svg>
              Encrypting...
            </span>
          </button>
        </form>
      </div>
    </div>
  </div>
</section> -->
</div>
